// Helpers for running inside the iPhone / iPad / Android app (built with Capacitor).
//
// Deliberately does NOT import any @capacitor package: the native shell injects
// window.Capacitor at runtime, so the normal website build never depends on it and
// keeps working exactly as before.

const cap = typeof window !== 'undefined' ? window.Capacitor : undefined;

export const isNative = !!(cap && typeof cap.isNativePlatform === 'function' && cap.isNativePlatform());
export const nativePlatform = isNative && typeof cap.getPlatform === 'function' ? cap.getPlatform() : 'web';

// Inside the app, window.location.origin is capacitor://localhost, which is useless in an
// email link. Anything that must open in a normal browser (e.g. password reset) uses this.
export const WEB_APP_URL = 'https://app.carcollectorstudio.com';
export const appOrigin = () => (isNative ? WEB_APP_URL : window.location.origin);

export const initNative = () => {
  if (!isNative) return;

  document.documentElement.classList.add('native-app', `native-${nativePlatform}`);
  const plugins = cap.Plugins || {};

  // Light status-bar text on the dark app background.
  try {
    plugins.StatusBar?.setStyle?.({ style: 'DARK' });
    // Full screen: the page draws behind the status bar and the gesture bar, no coloured bands.
    plugins.StatusBar?.setOverlaysWebView?.({ overlay: true });
    if (nativePlatform === 'android') plugins.StatusBar?.setBackgroundColor?.({ color: '#00000000' });
  } catch { /* cosmetic only */ }

  // Android hardware / gesture back: go back inside the app, leave the app from the first screen.
  try {
    plugins.App?.addListener?.('backButton', ({ canGoBack }) => {
      if (canGoBack) window.history.back();
      else plugins.App.exitApp?.();
    });
  } catch { /* the app still works without it */ }

  try { plugins.SplashScreen?.hide?.(); } catch { /* ignore */ }
};
